var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":"","id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('NotificationContainer'),_c('notifications',{attrs:{"group":"main","position":"top center","speed":500}}),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.fullPath,staticClass:"page"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }